export const percentStyle = { 
  style: 'percent', 
  minimumFractionDigits: 0, 
  maximumFractionDigits: 2
};

export function getLangCode(lang='en-US'):string{
  return document.documentElement.lang ?
    document.documentElement.lang : lang;
}

export function formatPercent(percent:number):string{
  return Intl.NumberFormat(getLangCode(),percentStyle).format(percent);
}